module.exports = __webpack_public_path__ + "static/media/sicherung_frage.ebbd4ae3.jpg";